// Dependencias generales
import React from "react";
import { useEffect, useState } from 'react';
import ReactGA from "react-ga4";
import imgNoResultsDark from '../../img/dark-theme/empty-state.svg'

const endpointHelias = "https://9m4y8iz04h.execute-api.eu-west-3.amazonaws.com/prod"
const postListInstallationActivity = endpointHelias+'/Helias/V0/General/postListInstallationActivity';	

var initialConfigCommonJS = require("../../js/initialConfigCommon.js")
var dashboardCommonJS = require("../../js/dashboardCommon.js")
var generalCommonJS = require("../../js/generalCommon.js")

// Función del router
const TodayInstallationActivity = (params) => {    

    useEffect(() => {                 
      console.log("Detalle de la actividad de hoy de la instalación cargado correctamente.")
      if (!document.getElementById("detalleACTIVIDAD_INSTALACION").className.includes("hidden")){

        cargarDatosActividadHoyInstalacion()
        
      }
    }, [params]);

    const [objListadoActividadHoy, setObjListadoActividadHoy] = useState([])  

  function cargarDatosActividadHoyInstalacion(){
      
      var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
      var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")        

      document.getElementById("loaderActividadDiaria").className = document.getElementById("loaderActividadDiaria").className.replaceAll(" hidden", "")

      var fechaActual = new Date();
      var añoActual = fechaActual.getFullYear();
      var mesActual = (fechaActual.getMonth()+1);
      var diaActual = fechaActual.getDate();
      var horaActual = fechaActual.getHours()
        
      if (mesActual < 10){ mesActual = "0"+mesActual;	}
      if (diaActual < 10){ diaActual = "0"+diaActual;	}
      if (horaActual < 10){ horaActual = "0"+horaActual; }
      
      var datePeticion = añoActual + "-" + mesActual + "-" + diaActual

      //Petición de datos para el paso actual
      var jsonPeticion = {
        "accountID": localStorage.getItem("accountID"),
        "installationID": localStorage.getItem("installationId"),
        "datetimeFrom": datePeticion+"T00:00:00",
        "datetimeTo": datePeticion+"T23:59:59",
        "filters": "activityCategory-actionId-actionStatusId-deviceId-deviceName-actionValue"
      }
      
      // Guardo la información  
      var xhttp = new XMLHttpRequest();  
        xhttp.open("POST", postListInstallationActivity, true);        
        xhttp.setRequestHeader('Content-Type', "application/json");
        xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
        var data = JSON.stringify(jsonPeticion);
        xhttp.onreadystatechange = function() {
          if (this.readyState === 4 && this.status === 200) {

            var jsonRespuesta = JSON.parse(this.responseText.replaceAll("\\", "\\\\"))

            if(jsonRespuesta.statusCode === "403"){                   
              initialConfigCommonJS.mostrarMensajeInformativo("No tiene permisos para realizar la operación.","negative")
            }
            else{          
              //Si recibo datos ya configurados lo cargo  

              if(typeof jsonRespuesta.body !== 'undefined'){

                if(jsonRespuesta.body.length >0){
                  setObjListadoActividadHoy(jsonRespuesta.body[0].DATA.reverse())
                }
                else{
                  setObjListadoActividadHoy([])
                }

                document.getElementById("loaderActividadDiaria").className += " hidden"
                
              }  

              //Si no hay datos configurados entonces no hago nada  
              console.log("Datos de la actividad de hoy de la instalación cargados correctamente.")
            }
          }
    
          if (this.readyState === 4 && this.status !== 200) {      
            initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)          
          }
        }
        xhttp.send(data);    
        
  }

  function irARegla(idRegla){
    localStorage.setItem("ruleDirectLink"+localStorage.getItem("installationId"),idRegla)
    params.seleccionarOpcionMenu("opcionMenuRules")
  }
  
      const listTodayActivity = objListadoActividadHoy.reverse().map((actividad,index) =>

        <React.Fragment key={index}>
          { actividad.actionValue.includes("·") ?
            [actividad.actionValue.split("·").length === 2 ?            
              <li key={index} className="horizontal gap-04 center" onClick={() => irARegla(actividad.actionValue.split("·")[1])}>
                <figure className={"avatar size-m "+dashboardCommonJS.obtenerColorIcono(actividad.activityCategory, actividad.actionStatusId)}><span className="material-icon">{dashboardCommonJS.obtenerIconoGrupoDispositivos(dashboardCommonJS.obtenerTipoDispositivo(actividad.deviceId, actividad.activityCategory))}</span></figure>
                <dl className="vertical fill">
                  <dt className="size-l">{dashboardCommonJS.obtenerNombreDispositivo(actividad.activityCategory,actividad.deviceName)}</dt>                                            
                    <dd className="size-s clarification vertical-center" style={{marginTop: "-7px"}}><span className="vertical-center">{dashboardCommonJS.formatearAFechaHoraCorta(actividad.DATETIME, "UTC").split("-")[0]} - {dashboardCommonJS.obtenerLiteralEstadoAccion(actividad.actionStatusId)} {actividad.actionValue.split("·")[0]} {dashboardCommonJS.obtenerUnidadAccion(actividad)} | </span><button className="link inline-link"><span className="vertical-center">Regla </span> <span className="size-s material-icon flip-right vertical-center">expand_circle_down</span></button></dd>                                  
                </dl> 
              </li>                
            :
            
              <li key={index} className="horizontal gap-04 center">          
                <figure className={"avatar size-m "+dashboardCommonJS.obtenerColorIcono(actividad.activityCategory, actividad.actionStatusId)}><span className="material-icon">{dashboardCommonJS.obtenerIconoGrupoDispositivos(dashboardCommonJS.obtenerTipoDispositivo(actividad.deviceId, actividad.activityCategory))}</span></figure>
                <dl className="vertical fill">
                  <dt className="size-l">{dashboardCommonJS.obtenerNombreDispositivo(actividad.activityCategory,actividad.deviceName)}</dt>                                            
                    <dd className="size-s clarification vertical-center" style={{marginTop: "-7px"}}>                      
                      { generalCommonJS.obtenerEmailUsuario() === dashboardCommonJS.obtenerDatosUsuarioActivadorAccion("email",actividad.actionValue) ?
                        <span className="vertical-center">{dashboardCommonJS.formatearAFechaHoraCorta(actividad.DATETIME, "UTC").split("-")[0]} - {dashboardCommonJS.obtenerLiteralEstadoAccion(actividad.actionStatusId)} {actividad.actionValue.split("·")[0]} {dashboardCommonJS.obtenerUnidadAccion(actividad)}</span>                                            
                      :
                        <span className="vertical-center">{dashboardCommonJS.formatearAFechaHoraCorta(actividad.DATETIME, "UTC").split("-")[0]} - {dashboardCommonJS.obtenerLiteralEstadoAccion(actividad.actionStatusId)} {actividad.actionValue.split("·")[0]} {dashboardCommonJS.obtenerUnidadAccion(actividad)} por {dashboardCommonJS.obtenerDatosUsuarioActivadorAccion("nombreLargo",actividad.actionValue)}</span>                                                                    
                      } 
                    </dd>                    
                </dl>                 
              </li>                
            ]

          :
            <li key={index} className="horizontal gap-04 center">
              <figure className={"avatar size-m "+dashboardCommonJS.obtenerColorIcono(actividad.activityCategory, actividad.actionStatusId)}><span className="material-icon">{dashboardCommonJS.obtenerIconoGrupoDispositivos(dashboardCommonJS.obtenerTipoDispositivo(actividad.deviceId, actividad.activityCategory))}</span></figure>
              <dl className="vertical fill">
                <dt className="size-l">{dashboardCommonJS.obtenerNombreDispositivo(actividad.activityCategory,actividad.deviceName)}</dt>                            
                  <dd className="size-s clarification">{dashboardCommonJS.formatearAFechaHoraCorta(actividad.DATETIME, "UTC").split("-")[0]} - {dashboardCommonJS.obtenerLiteralEstadoAccion(actividad.actionStatusId)} {actividad.actionValue.split("·")[0]} {dashboardCommonJS.obtenerUnidadAccion(actividad)}</dd>                    
              </dl> 
            </li>                            
          }
        </React.Fragment>        
     
      );    

      return (
        
        <>

        <button className="button primary full-width" onClick={() => params.seleccionarOpcionMenu("opcionMenuInstallationActivity")}>
          <span className="material-icon">signal_cellular_alt</span>
          Ver actividad de otros días
        </button>

        { 
        
          (() => {

                if((objListadoActividadHoy.length > 0)){

                  return <>
                            <ul className="vertical gap-04" aria-label="Actividad de hoy">
                              {listTodayActivity}  
                            </ul>

                            <div id="loaderActividadHoy" className="loader hidden">
                              <progress aria-label={params.Mensaje} style={{display: 'block', position: 'relative', margin: 'auto'}}></progress>          
                            </div>        
                          </>
                }
                else{

                  return <div className="message medium empty">
                            <picture>
                              <source srcSet={imgNoResultsDark} media="(prefers-color-scheme: dark)"/>
                              <img src={imgNoResultsDark} alt=""/>
                            </picture>

                            { localStorage.getItem("lastSmartDevicesStatus") !== null && JSON.parse(localStorage.getItem("lastSmartDevicesStatus")).length > 0 ?
                              <h1 className="title">Hoy no ha habido actividad de <button className="link inline-link" onClick={() => dashboardCommonJS.operarMenuDispositivos("abrir", params.setObjDevicesUpdateTimestamp, ReactGA)}>dispositivos</button> ni <button className="link inline-link" onClick={() => params.seleccionarOpcionMenu("opcionMenuRules")}>reglas</button> en tu instalación</h1>
                            :
                              <h1 className="title">Hoy no ha habido actividad de <button className="link inline-link" onClick={() => params.seleccionarOpcionMenu("opcionMenuRules")}>reglas</button> en tu instalación</h1>
                            }
                            
                            
                          </div>      
                }            

          })()

        } 
        </>
      )

}

export default TodayInstallationActivity